import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useIsDesktop, useIsMobile } from '~/context/common/DeviceContext';
import { useStickyBanner } from '~/context/vdp/StickyBannerContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import Price from './Price';
import UnavailableHeroContent from './UnavailableHeroContent';
import Badge from '../Badge';

export default function HeroContent() {
  const { year = 0, make = '', model = '', trim = '' } = useGetVehicleDetails();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();
  const { setShouldShowStickyBanner } = useStickyBanner();

  const [ref, inView] = useInView({
    threshold: [0, 1],
    initialInView: true // Assume in view initially to prevent flash
  });

  useEffect(() => {
    if (isMobile) {
      setShouldShowStickyBanner(!inView);
    }
  }, [inView, isMobile, setShouldShowStickyBanner]);

  return (
    <div className="flex flex-col gap-md">
      {isDesktop ? (
        <UnavailableHeroContent />
      ) : (
        <>
          <Badge />
          <div className="text-text-strong t-heading-sm">
            <div>
              {year} {make} {model}
            </div>
            <div className="mb-sm text-text-weak t-body-sm">{trim}</div>
            <div ref={ref}>
              <Price />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
